import React from 'react';
import {
  string,
  shape,
} from 'prop-types';
import { Small } from 'components/common';
import CompareElementValue from '../CompareElementValue';

import './MobilePremiumCompareElement.scss';

const MobilePremiumCompareElement = ({
  title,
  displayValue,
  prefix,
  suffix,
  description,
  originalPrice,
  originalPriceLabel,
}) => (
  <div className="mobile-premium-compare-element">
    <Small bold block className="title">
      {title.display}
    </Small>
    {displayValue && (
      <div className="value">
        <CompareElementValue
          value={displayValue}
          prefix={prefix}
          suffix={suffix}
          isMobilePremium
        />
      </div>
    )}
    {description && description !== 'BLANK_ENTRY' && (
      <Small secondary block className="description">
        {description}
      </Small>
    )}
    {originalPriceLabel && (
      <Small secondary bold block className="original-value-description">
        {originalPriceLabel}
        &nbsp;
        <del>
          {prefix}
          {originalPrice}
        </del>
      </Small>
    )}
  </div>
);

MobilePremiumCompareElement.propTypes = {
  title: shape({
    display: string,
    key: string,
  }),
  displayValue: string.isRequired,
  description: string,
  prefix: string,
  suffix: string,
  originalPriceLabel: string,
  originalPrice: string,
};

MobilePremiumCompareElement.defaultProps = {
  title: {},
  description: null,
  prefix: null,
  suffix: null,
  originalPrice: null,
  originalPriceLabel: null,
};

export default MobilePremiumCompareElement;
